import React from "react";
import { getImage } from "../../../../../utils/getImages";
import "./app.css";
const PressRelaseCard = ({ cardData, activetab }) => {
  return (
    <div style={{ margin: "10px" }}>
      <h1 className="title-color center" style={{ textAlign: "center" }}>
        {activetab === "english"
          ? cardData?.title
          : activetab === "simplified_chinese"
          ? cardData?.simplified_chinese_title
          : activetab === "arabic"
          ? cardData?.arabic_title
          : activetab === "bahasa"
          ? cardData?.bahasa_title
          : cardData?.traditional_chinese_title}
      </h1>
      <h5 className="subtitle-color mb-4" style={{ direction: activetab === "arabic" && "rtl",textAlign:"center" }}>
               {activetab === "english"
                ? cardData?.sub_title
                : activetab === "simplified_chinese"
                ? cardData?.simplified_chinese_sub_title
                : activetab === "bahasa"
                ? cardData?.bahasa_sub_title
                : cardData?.traditional_chinese_sub_title} 
          </h5>
      <table
        className="table"
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: "10px",
        }}
      >
        <tbody>
          {cardData?.dataArray?.map((item, index) => (
            <tr key={index}>
              <td
                style={{
                  border: "1px solid gray",
                  padding: "8px",
                  color: "black",
                }}
              >
                {activetab === "english"
                  ? item?.date
                  : activetab === "simplified_chinese"
                  ? item?.simplified_chinese_date
                  : activetab === "arabic"
                  ? item?.arabic_date
                  : activetab === "bahasa"
                  ? item?.bahasa_date
                  : item?.traditional_chinese_date}
              </td>
              <td
                style={{
                  border: "1px solid gray",
                  padding: "8px",
                  color: "gray",
                }}
              >
                {activetab === "english"
                  ? item?.title
                  : activetab === "simplified_chinese"
                  ? item?.simplified_chinese_title
                  : activetab === "arabic"
                  ? item?.arabic_title
                  : activetab === "bahasa"
                  ? item?.bahasa_title
                  : item?.traditional_chinese_title}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PressRelaseCard;
